import { render, staticRenderFns } from "./bsp-collapsible-module.vue?vue&type=template&id=5ccc6776&scoped=true&"
import script from "./bsp-collapsible-module.vue?vue&type=script&lang=js&"
export * from "./bsp-collapsible-module.vue?vue&type=script&lang=js&"
import style0 from "./bsp-collapsible-module.vue?vue&type=style&index=0&id=5ccc6776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccc6776",
  null
  
)

export default component.exports